var React = require('react');

function ArrowLineRight (props) {
    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M9.94 6.127H.616a.563.563 0 0 1-.435-.185A.592.592 0 0 1 0 5.496c0-.177.057-.329.18-.446a.594.594 0 0 1 .436-.186H9.94l-2.7-2.77a.6.6 0 0 1-.181-.437c0-.169.065-.32.18-.447a.567.567 0 0 1 .87-.017l3.678 3.772c.073.076.13.16.164.253.033.084.049.185.049.286a.738.738 0 0 1-.213.539L8.109 9.815a.588.588 0 0 1-.435.185.605.605 0 0 1-.443-.202.723.723 0 0 1-.189-.446c0-.169.058-.312.19-.446l2.7-2.77.008-.009z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"d":"M0 0h12v12H0z"})))]);
}

ArrowLineRight.displayName = "ArrowLineRight";

ArrowLineRight.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = ArrowLineRight;

ArrowLineRight.default = ArrowLineRight;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-line-right.svg
// module id = 1254
// module chunks = 0